"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3660],{

/***/ 82786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LoadingOverlay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react_loading_overlay_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45414);




var LoadingOverlay = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_loading_overlay_ts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        spinner: true,
        fadeSpeed: 100,
        styles: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            spinner: function(base) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, base), {
                    width: "100px",
                    "& svg circle": {
                        stroke: "rgba(210, 214, 219, 0.5)"
                    }
                });
            }
        }, props.styles)
    }));
};


/***/ }),

/***/ 70324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ToggleSortIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var ToggleSortIcon = function(props) {
    var iconName = props.type === "asc" ? "arrow8-up" : props.type === "desc" ? "arrow8-down" : "sort-fill";
    var color = props.type === null ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray70 */ .O9.gray70 : "#1f9db8";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        onClick: props.onClick,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:15px;display:flex;align-items:center;justify-content:center;margin-left:5px;height:22px;width:22px;:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50, ";border-radius:50%;cursor:pointer;}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: iconName,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", color, ";margin-top:", props.type === "desc" ? "3px" : 0, ";margin-bottom:", props.type === "asc" ? "3px" : 0, ";")
        })
    });
};


/***/ }),

/***/ 28695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ CompaniesTableBody; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/atoms/Table.tsx
var Table = __webpack_require__(14792);
// EXTERNAL MODULE: ./lib/company.ts
var lib_company = __webpack_require__(10133);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
// EXTERNAL MODULE: ./components/atoms/FormattedNumber.tsx
var FormattedNumber = __webpack_require__(98257);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./components/atoms/icons/IPOIcon.tsx
var IPOIcon = __webpack_require__(86996);
// EXTERNAL MODULE: ./components/atoms/LineClampText.tsx
var LineClampText = __webpack_require__(89277);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
;// CONCATENATED MODULE: ./components/common/table/internal/CompanySummaryCell.tsx












var MAX_TAGS = 6;
var CompanySummaryCell = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
        className: props.className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        as: props.company.path,
                        href: url/* COMPANY_HREF */.bP,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                src: props.company.imageUrl || "/static/images/default/company.png",
                                size: "normal",
                                name: props.company.name
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;margin-left:10px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "company-name",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    as: props.company.path,
                                    href: url/* COMPANY_HREF */.bP,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        decoration: "none",
                                        children: props.company.name
                                    })
                                }),
                                (0,lib_company/* isIPO */.sH)(props.company) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IPOIcon/* IPOIcon */.K, {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:3px;")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                            justify: true,
                            lineNumber: 5,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:1.5;"),
                            stripLineBreaks: true,
                            children: props.company.description
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:6px;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagButton/* TagButtonGroup */.U, {
                                children: [
                                    props.company.tags.slice(0, MAX_TAGS).map(function(tag, i) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                            tag: tag
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ellipsis, {
                                        rest: props.company.tags.slice(MAX_TAGS).map(function(tag) {
                                            return "#".concat(tag.name);
                                        }).join(", ")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var Ellipsis = function(param) {
    var rest = param.rest;
    return rest ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        title: rest,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:2px;line-height:1.2;"),
        children: "..."
    }) : null;
};

;// CONCATENATED MODULE: ./components/common/table/CompaniesTableBody.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: ",
        ";\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var CompaniesTableBody = function(param) {
    var items = param.items, totalFunding = param.withTotalFunding;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
        children: items.map(function(company, i) {
            var ref;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                highlightOnHover: true,
                className: "row",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummaryCell, {
                        company: company,
                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), totalFunding ? "50%" : "60%")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                        nowrap: true,
                        centerized: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                            children: company.establishedAt
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                        nowrap: true,
                        centerized: true,
                        className: "last-funding-date",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                            children: (ref = company.latestFundraise) === null || ref === void 0 ? void 0 : ref.date
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                        centerized: true,
                        children: (0,lib_company/* isPrivate */.hv)(company) && company.latestInitialSeries
                    }),
                    totalFunding && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                        vertical: "middle",
                        align: "right",
                        className: "total-fundraise",
                        children: company.totalFundraise && company.totalFundraise !== 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedNumber/* FormattedNumber */.B, {
                            sub: company.hasEstimatedRound ? "（推測）" : "",
                            children: company.totalFundraise && company.totalFundraise
                        }) : ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                        vertical: "middle",
                        align: "right",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedNumber/* FormattedNumber */.B, {
                            sub: (0,lib_company/* isIPO */.sH)(company) ? "IPO前最終調達時" : company.hasEstimatedRound ? "（推測）" : "",
                            children: company.valuation
                        })
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 91830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ CompaniesTableHead; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_search_ToggleSortIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70324);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14792);






var CompaniesTableHead = function(param) {
    var sort = param.sort, sticky = param.sticky, offset = param.offset, totalFunding = param.withTotalFunding, onToggleSort = param.onToggleSort;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHead */ .ss, {
        sticky: sticky,
        offset: offset,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("tr", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("> th{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white10 */ .O9.white10, ";}"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    children: "企業名"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    children: [
                        "設立年月日",
                        sort && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_search_ToggleSortIcon__WEBPACK_IMPORTED_MODULE_2__/* .ToggleSortIcon */ .R, {
                            type: sort.key === "established" ? sort.order : null,
                            onClick: function() {
                                return onToggleSort && onToggleSort("established");
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                    children: "最新ラウンド"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                    children: "調達日"
                                })
                            ]
                        }),
                        sort && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_search_ToggleSortIcon__WEBPACK_IMPORTED_MODULE_2__/* .ToggleSortIcon */ .R, {
                            type: sort.key === "lastFundraised" ? sort.order : null,
                            onClick: function() {
                                return onToggleSort && onToggleSort("lastFundraised");
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    align: "center",
                    help: "スピーダが独自に定義する成長フェーズ",
                    helpProps: {
                        linkTo: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA",
                        //ref: https://github.com/Japan-Venture-Research/penguin/pull/964
                        offset: {
                            top: sort ? 0 : 10
                        }
                    },
                    children: [
                        "スピーダ",
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("br", {}),
                        "調達シリーズ"
                    ]
                }),
                totalFunding && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                    children: "総調達額"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .SubLabel */ .vQ, {
                                    children: "千円"
                                })
                            ]
                        }),
                        sort && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_search_ToggleSortIcon__WEBPACK_IMPORTED_MODULE_2__/* .ToggleSortIcon */ .R, {
                            type: sort.key === "totalFunding" ? sort.order : null,
                            onClick: function() {
                                return onToggleSort && onToggleSort("totalFunding");
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                    children: "調達後評価額"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .SubLabel */ .vQ, {
                                    children: "千円"
                                })
                            ]
                        }),
                        sort && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_search_ToggleSortIcon__WEBPACK_IMPORTED_MODULE_2__/* .ToggleSortIcon */ .R, {
                            type: sort.key === "valuation" ? sort.order : null,
                            onClick: function() {
                                return onToggleSort && onToggleSort("valuation");
                            }
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 10133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ isDomesticCompanyData; },
/* harmony export */   "EC": function() { return /* binding */ isExited; },
/* harmony export */   "Js": function() { return /* binding */ isHyperLink; },
/* harmony export */   "UX": function() { return /* binding */ isResearchDone; },
/* harmony export */   "a5": function() { return /* binding */ isResearchUnvalued; },
/* harmony export */   "hD": function() { return /* binding */ isResearchContinue; },
/* harmony export */   "hv": function() { return /* binding */ isPrivate; },
/* harmony export */   "m8": function() { return /* binding */ checkMemoUpdatedWithinOneWeek; },
/* harmony export */   "rV": function() { return /* binding */ splitMemoContentWithHyperLink; },
/* harmony export */   "sH": function() { return /* binding */ isIPO; },
/* harmony export */   "tP": function() { return /* binding */ companyDefaultImage; },
/* harmony export */   "vg": function() { return /* binding */ companyTabLabel; }
/* harmony export */ });
/* unused harmony exports fetchArticlesByCompany, fetchContentfulCompany, splitMemoContentWithHyperLinkForCompany */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _api_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58585);
/* harmony import */ var _article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9427);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79240);







var companyTabLabel = {
    "basic-info": "企業概要",
    "finance-info": "ファイナンス",
    news: "ニュース",
    shareholders: "株主",
    directors: "役員",
    performances: "業績",
    employees: "従業員数",
    partnerships: "提携先",
    benchmarks: "類似企業",
    others: "その他",
    "ipo-data": "IPOデータ"
};
var isDomesticCompanyData = function(company) {
    return typeof company.shortname !== "undefined";
};
var isPrivate = function(company) {
    return company.recordType === "未公開企業";
};
var isIPO = function(company) {
    return company.recordType === "IPO企業";
};
var isResearchContinue = function(company) {
    return isPrivate(company) && /調査継続/.test(company.researchStatus);
};
var isResearchUnvalued = function(company) {
    return isPrivate(company) && /未評価/.test(company.researchStatus);
};
var isExited = function(company) {
    return !!company.exited;
};
var isResearchDone = function(company) {
    return !isResearchContinue(company) && !isResearchUnvalued(company);
};
var companyDefaultImage = function(type) {
    return type === "未公開企業" ? "/static/images/default/company.png" : "/static/images/default/ipo.png";
};
var fetchArticlesByCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(companyId) {
        var articles, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    articles = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getArticlesByCompany */ .BB)(companyId)
                    ];
                case 2:
                    data = _state.sent();
                    articles = data.items.map(function(res) {
                        return (0,_article__WEBPACK_IMPORTED_MODULE_1__/* .convertArticle */ .AP)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.fields), {
                            id: res.sys.id
                        }));
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        articles
                    ];
            }
        });
    });
    return function fetchArticlesByCompany(companyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchContentfulCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var company, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    company = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getContentfulCompany */ .kf)(shortname)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        company = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_6__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        company
                    ];
            }
        });
    });
    return function fetchContentfulCompany(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var checkMemoUpdatedWithinOneWeek = function(companyMemo) {
    if (companyMemo == null) return false;
    var day = new Date();
    day.setDate(day.getDate() - 7);
    return day < new Date(companyMemo.updated);
};
var splitMemoContentWithHyperLinkForCompany = function(companyMemo) {
    if (!companyMemo || !companyMemo.content) return [];
    var urlRegex = /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g;
    var nonUrlRegex = /[^:\w!?/+\-_~;.,*&@#$%()'[\]]+/g;
    if (!urlRegex.test(companyMemo.content)) return [
        companyMemo.content
    ];
    var putContentPart = function(str, contentParts) {
        var idx = str.search(isHyperLink(str) ? nonUrlRegex : urlRegex);
        if (idx === -1) return contentParts.concat(str);
        var firstStr = str.slice(0, idx);
        var secondStr = str.slice(idx);
        return putContentPart(secondStr, contentParts.concat(firstStr));
    };
    return putContentPart(companyMemo.content, []);
};
var splitMemoContentWithHyperLink = function(companyMemo) {
    if (!companyMemo || !companyMemo.content) return [];
    var urlRegex = /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g;
    var nonUrlRegex = /[^:\w!?/+\-_~;.,*&@#$%()'[\]]+/g;
    if (!urlRegex.test(companyMemo.content)) return [
        companyMemo.content
    ];
    var putContentPart = function(str, contentParts) {
        var idx = str.search(isHyperLink(str) ? nonUrlRegex : urlRegex);
        if (idx === -1) return contentParts.concat(str);
        var firstStr = str.slice(0, idx);
        var secondStr = str.slice(idx);
        return putContentPart(secondStr, contentParts.concat(firstStr));
    };
    return putContentPart(companyMemo.content, []);
};
var isHyperLink = function(str) {
    return str.startsWith("http");
};


/***/ })

}]);